import { ComponentPropsWithRef, forwardRef, memo } from 'react';
import { ClientOnly, IconButton, Skeleton } from '@chakra-ui/react';

import { useColorMode } from './hooks/useColorMode';
import { ColorModeButtonProps } from './types/ColorModeButtonProps';
import { ColorModeIcon } from './ColorModeIcon';

const iconButtonStyles = {
  _icon: {
    width: '5',
    height: '5',
  },
};

const ColorModeButtonComponent = (
  props: ColorModeButtonProps,
  ref: ComponentPropsWithRef<'button'>['ref'],
) => {
  const { toggleColorMode } = useColorMode();
  return (
    <ClientOnly fallback={<Skeleton boxSize="9" />}>
      <IconButton
        ref={ref}
        aria-label="Toggle color mode"
        onClick={toggleColorMode}
        size="sm"
        variant="ghost"
        {...props}
        css={iconButtonStyles}
      >
        <ColorModeIcon />
      </IconButton>
    </ClientOnly>
  );
};

export const ColorModeButton = memo(
  forwardRef<HTMLButtonElement, ColorModeButtonProps>(ColorModeButtonComponent),
);
